import { ToastOptions } from "react-toastify";

export const DEFAULT_OPTIONS: Partial<ToastOptions> = {
  position: "bottom-center",
  closeButton: false,
  hideProgressBar: true,
};
